import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig';
import { FormGroupListResp } from 'domain/payload/response/form-group/FormGroupListResp';
import { FormGroupDetailResp } from 'domain/payload/response/form-group/FormGroupDetailResp';
import { FormGroupSaveReq } from 'domain/payload/request/form-group/FormGroupSaveReq';

const FormGroupService = () => {
  const formGroupList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<FormGroupListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/form-group/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error;
    }
  };

  const formGroupDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<FormGroupDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/form-group/detail`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          id: id
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error;
    }
  };

  const formGroupSave = async (
    token: string,
    req: FormGroupSaveReq
  ): Promise<BaseResponse<FormGroupDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/form-group/save`, req, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error;
    }
  };

  const formGroupDelete = async (
    token: string,
    id: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(`/v1/legacy/cms/form-group/delete`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          id: id
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error;
    }
  };

  return {
    formGroupList,
    formGroupDetail,
    formGroupSave,
    formGroupDelete
  };
};

export default FormGroupService;
